import React from "react";

const ICONS = {
  "first-use": (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#CBD5E1" strokeWidth="1.5" aria-hidden="true">
      <rect x="3" y="3" width="18" height="18" rx="2"/>
      <line x1="3" y1="9" x2="21" y2="9"/>
      <line x1="3" y1="15" x2="21" y2="15"/>
      <line x1="9" y1="9" x2="9" y2="21"/>
    </svg>
  ),
  "no-results": (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#CBD5E1" strokeWidth="1.5" aria-hidden="true">
      <circle cx="11" cy="11" r="8"/>
      <line x1="21" y1="21" x2="16.65" y2="16.65"/>
    </svg>
  ),
  error: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#EF4444" strokeWidth="1.5" aria-hidden="true">
      <circle cx="12" cy="12" r="10"/>
      <line x1="12" y1="8" x2="12" y2="12"/>
      <line x1="12" y1="16" x2="12.01" y2="16"/>
    </svg>
  ),
};

const DEFAULT_TITLES = {
  "first-use": "No data yet",
  "no-results": "No results found",
  error: "Failed to load",
};

/**
 * @param {"first-use"|"no-results"|"error"} variant
 * @param {string} [title]               — overrides default title for variant
 * @param {string} [description]         — shown below title; omit to hide
 * @param {{ label: string, onClick: fn }} [action]
 * @param {React.ReactNode} [icon]       — overrides default icon for variant
 * @param {string} [className]
 */
const EmptyState = ({
  variant = "first-use",
  title,
  description,
  action,
  icon,
  className = "",
}) => {
  const resolvedDescription =
    description === undefined ? null : description;

  return (
    <div
      className={`flex flex-col items-center justify-center py-12 gap-2 ${className}`}
      role="status"
    >
      <div
        className={`w-11 h-11 rounded-xl flex items-center justify-center mb-1 ${
          variant === "error" ? "bg-error-light" : "bg-gray-50"
        }`}
      >
        {icon ?? ICONS[variant] ?? ICONS["first-use"]}
      </div>

      <p className="text-sm font-medium text-ink">
        {title ?? DEFAULT_TITLES[variant] ?? "No data"}
      </p>

      {resolvedDescription && (
        <p className="text-xs text-ink-muted text-center max-w-[240px] leading-relaxed">
          {resolvedDescription}
        </p>
      )}

      {action && (
        <button
          onClick={action.onClick}
          className={
            variant === "error"
              ? "mt-2 text-xs text-primary border border-primary/20 bg-primary-light px-3 py-1.5 rounded-lg hover:bg-primary hover:text-white transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/30"
              : "mt-1 text-xs text-primary hover:underline focus-visible:outline-none"
          }
        >
          {action.label}{variant !== "error" && " →"}
        </button>
      )}
    </div>
  );
};

export default EmptyState;
